import { AxiosResponse } from "axios";
import httpClient, { apiRoutePrefix } from "../httpClient/httpClient";

export interface CreateThirdPartyAppPayload {
  name: string;
  user_id: number;
  helen_id?: number;
  description?: string | null;
  base_url?: string | null;
}

export interface ThirdPartyApp {
  id: number;
  name: string;
  user_id: number;
  helen_id: number;
  description: string | null;
  api_key: string;
  base_url: string | null;
  is_active?: boolean;
  status?: string;
}

export const ThirdPartyAppsService = {
  async createApp(payload: CreateThirdPartyAppPayload): Promise<AxiosResponse<{ app: ThirdPartyApp }>> {
    return httpClient.post(`${apiRoutePrefix}/optimizely/connectApp`, payload);
  },

  async getApps(): Promise<AxiosResponse<{ data: ThirdPartyApp[] }>> {
    return httpClient.get(`${apiRoutePrefix}/getThirdPartyApps`);
  },

  async getAppById(id: number): Promise<AxiosResponse<{ app: ThirdPartyApp }>> {
    return httpClient.get(`${apiRoutePrefix}/getThirdPartyAppById/${id}`);
  },

  async updateApp(
    id: number,
    payload: Partial<Omit<ThirdPartyApp, "id" | "api_key">>
  ): Promise<AxiosResponse<{ app: ThirdPartyApp }>> {
    return httpClient.put(`${apiRoutePrefix}/updateThirdPartyApp/${id}`, payload);
  },

  async regenerateApiKey(id: number): Promise<AxiosResponse<{ app: ThirdPartyApp }>> {
    // Backend should implement this route to generate and persist a new api_key
    return httpClient.post(`${apiRoutePrefix}/regenerateThirdPartyAppKey/${id}`);
  },

	async deleteApp(id: number): Promise<AxiosResponse<{ success: boolean }>> {
		return httpClient.delete(`${apiRoutePrefix}/deleteThirdPartyApp/${id}`);
	},
};
